import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchContentTagViewPatterns } from 'api/content-tag.service';
import { notificationActions } from 'redux/notification/notification.slice';
import { ContentTagViewPatternResponse } from 'types/entity';

export const VIEW_PATTERN_READ_STORE_NAME = 'viewPatternRead';

export const loadViewPatternList = createAsyncThunk(
  `${VIEW_PATTERN_READ_STORE_NAME}/load`,
  async (payload: { projectId: string, contentTagId: string }, thunkAPI) => {
    const { projectId, contentTagId } = payload;
    const response = await fetchContentTagViewPatterns(projectId, contentTagId)
      .catch((error) => {
        // notification warn
        thunkAPI.dispatch(notificationActions.addWarning({ messageId: 'FpFolderSearch.notification.warn.view-pattern-not-found' }));
        throw new Error(error);
      });
    return response;
  },
);

export interface ViewPatternReadState {
  entities: ContentTagViewPatternResponse[]
  loaded: boolean
  error: any
}

export const initialViewPatternReadState: ViewPatternReadState = {
  entities: [],
  loaded: false,
  error: null,
};

export const viewPatternReadSlice = createSlice({
  name: VIEW_PATTERN_READ_STORE_NAME,
  initialState: initialViewPatternReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadViewPatternList.pending, (state) => {
      state.entities = [];
      state.loaded = false;
    });
    builder.addCase(loadViewPatternList.fulfilled, (state, action) => {
      state.entities = action.payload;
      state.loaded = true;
    });
    builder.addCase(loadViewPatternList.rejected, (state, action) => {
      state.loaded = true;
      state.error = action.payload;
    });
  },
});

export const viewPatternReadAction = {
  ...viewPatternReadSlice.actions,
  loadViewPatternList,
};

export default viewPatternReadSlice.reducer;
